import { Table2Columns } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconTable2Columns12Line = createIcon(Table2Columns, 12, "Line");
export const IconTable2Columns16Line = createIcon(Table2Columns, 16, "Line");
export const IconTable2Columns20Line = createIcon(Table2Columns, 20, "Line");
export const IconTable2Columns24Line = createIcon(Table2Columns, 24, "Line");
export const IconTable2Columns32Line = createIcon(Table2Columns, 32, "Line");
export const IconTable2Columns48Line = createIcon(Table2Columns, 48, "Line");
export const IconTable2Columns64Line = createIcon(Table2Columns, 64, "Line");
